<template>
  <div id="app">
    <div id="nav">
      <Menu v-if="ready" />
      <Auth v-if="auth" @exit="authExit" />
      <Miner v-if="mine" />
    </div>
    <div class="conent-page">
        <router-view/>
    </div>
  </div>
</template>

<script>

import Menu from '@/components/Menu.vue'
import Auth from '@/components/Auth.vue'
import Miner from '@/views/Miner.vue'

export default {
  components: {
    Menu,
    Auth,
    Miner
  },
  data () {
    return {
      auth: false,
      ready: false,
      mine: true
    }
  },
  methods: {
    authExit ( resp ) {
      console.log('resp',resp);
    }
  }
}

</script>

<style lang="scss">
.password.v-alert-container .v-alert {
  div.x {
    right: 17px;
  }
}  
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
